// Shared so the status mutation can patch the exact page the map is reading.
export const caseMapMachinesKey = (caseRouteId, filterParams) => [
  "case-map-machines",
  caseRouteId,
  filterParams,
];

export const machineApprovalStatusesKey = ["machine-approval-statuses"];
